import api from './api';

export interface StatementUploadResponse {
  status: string;
  message: string;
  transactions?: Array<{
    date: string;
    merchant: string;
    amount: number;
    category: string;
  }>;
  analysis?: {
    total_spent: number;
    by_category: { [key: string]: number };
    potential_savings: number;
    missed_savings: number;
    recommendations: Array<{
      transaction: string;
      date: string;
      amount: number;
      category: string;
      used_card: string;
      reward_earned: number;
      recommended_card: string;
      potential_reward: number;
      missed_savings: number;
    }>;
    card_performance?: { [key: string]: { total_spent: number; transaction_count: number } };
  };
  saved_count?: number;
  file_path?: string;
}

export const statementService = {
  uploadStatement: async (file: File, cardId?: number): Promise<StatementUploadResponse> => {
    const formData = new FormData();
    formData.append('statement', file);
    if (cardId) {
      formData.append('card_id', cardId.toString());
    }
    
    try {
      // Don't set Content-Type header - let browser set it automatically with boundary
      const response = await api.post('/transactions/upload/', formData, {
        headers: {
          // Remove Content-Type to let browser set it with boundary for multipart/form-data
        },
        timeout: 300000, // 5 minutes timeout for large files
      });
      return response.data;
    } catch (error: any) {
      // Better error handling
      if (error.response) {
        throw new Error(error.response.data?.message || error.response.data?.detail || 'Upload failed');
      } else if (error.request) {
        throw new Error('Network error: Could not reach server');
      } else {
        throw new Error(error.message || 'Upload failed');
      }
    }
  },
};
